import React, { Component } from 'react';
import { WhiteSpace } from '@/components';
import { Tabs } from 'antd';
import Top from './_components/Top';
import MarginCash from './_components/MarginCash';
const TabPane = Tabs.TabPane;
class CashManage extends Component {
    render() {
        return (<React.Fragment>
        <Top />
        <WhiteSpace />
        <Tabs type="card">
          <TabPane tab="保证金提现管理" key="margin">
            <MarginCash />
          </TabPane>
        </Tabs>
      </React.Fragment>);
    }
}
export default CashManage;
